import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { PawPrint } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-xl border border-[#E4DFD3] bg-white px-4 py-3 text-sm text-[#142526] placeholder:text-[#9AA5A5] focus:outline-none focus:ring-2 focus:ring-[#FF6B4A] focus:border-transparent transition";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("admin_token", data.access_token);
      localStorage.setItem("admin_user", JSON.stringify(data.user));
      navigate("/admin/leads");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E4DFD3] p-10 shadow-xl">
        <div className="flex items-center gap-2.5 mb-8">
          <span className="w-10 h-10 rounded-full bg-[#0D3B3E] flex items-center justify-center">
            <PawPrint className="w-5 h-5 text-[#F7C948]" />
          </span>
          <span className="font-display font-extrabold text-xl text-[#0D3B3E]">Franchise Admin</span>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="admin-login-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="admin-login-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full rounded-full bg-[#FF6B4A] hover:bg-[#E55636] disabled:opacity-60 text-white font-semibold px-7 py-3.5 transition-colors"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <Link to="/" className="block mt-6 text-center text-sm text-[#5C6B6C] hover:text-[#0D3B3E]" data-testid="admin-login-back-link">
          Back to site
        </Link>
      </div>
    </div>
  );
}
